var _path, _path2, _ellipse, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallClearJarOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 59,
    viewBox: "0 0 32 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10V8H8.5C8.22386 8 8 7.77614 8 7.5C8 7.22386 8.22386 7 8.5 7H9V5H8.5C8.22386 5 8 4.77614 8 4.5C8 4.22386 8.22386 4 8.5 4H9H23H23.5C23.7761 4 24 4.22386 24 4.5C24 4.77614 23.7761 5 23.5 5H23V7H23.5C23.7761 7 24 7.22386 24 7.5C24 7.77614 23.7761 8 23.5 8H23V10H23.5C23.7761 10 24 10.2239 24 10.5C24 10.7761 23.7761 11 23.5 11H23V13H28V15C30.2091 15 32 16.7909 32 19V55C32 57.2091 30.2091 59 28 59H4C1.79086 59 0 57.2091 0 55V19C0 16.7909 1.79086 15 4 15V13H9V11H8.5C8.22386 11 8 10.7761 8 10.5C8 10.2239 8.22386 10 8.5 10H9Z",
    fill: "#CCD8E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23H30V53C30 55.2091 28.2091 57 26 57H6C3.79086 57 2 55.2091 2 53V23Z",
    fill: "#33BEF2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 23,
    rx: 14,
    ry: 1,
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2 21C2 18.7909 3.79086 17 6 17H10V57H6C3.79086 57 2 55.2091 2 53V21Z",
    fill: "#F5F7F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 28 7.6 28.6674 16 28.6674C24.4 28.6674 32 28 32 28V49.3326C32 49.3326 24.8 50 16 50C7.2 50 0 49.3326 0 49.3326V28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallClearJarOpen);
export default __webpack_public_path__ + "static/media/small_clear_jar_open.9b5272b8dd00d99bdfac6646582b64d8.svg";
export { ForwardRef as ReactComponent };